const tickStampComponentDefinition = {
    template: '<div class="digitalPayTickStamp-wrapper"><i class="iconww-Tick digitalPayTickStamp"></i></div>',
};

module.exports = tickStampComponentDefinition;



// WEBPACK FOOTER //
// ./src/wallet/common/digital-pay-tick-stamp.component.js